import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

import { cn } from "@redotech/arbiter/tailwind-utils";

const skeletonVariants = cva("animate-pulse bg-muted rounded-md", {
  variants: {
    variant: { rectangle: "", circle: "rounded-full", text: "h-4 rounded" },
    size: { sm: "h-4", md: "h-6", lg: "h-8" },
  },
  defaultVariants: { variant: "rectangle", size: "md" },
});

export interface SkeletonProps
  extends
    Omit<React.ComponentProps<"div">, "width" | "height">,
    VariantProps<typeof skeletonVariants> {
  /**
   * Custom width override
   */
  width?: string | number;
  /**
   * Custom height override
   */
  height?: string | number;
}

const Skeleton = React.memo(
  React.forwardRef<HTMLDivElement, SkeletonProps>(function Skeleton(
    { className, variant, size, width, height, style, ...props },
    ref,
  ) {
    const customStyle = {
      ...style,
      ...(width && { width }),
      ...(height && { height }),
    };

    return (
      <div
        className={cn(skeletonVariants({ variant, size }), className)}
        data-slot="skeleton"
        ref={ref}
        style={customStyle}
        {...props}
      />
    );
  }),
);

export { Skeleton, skeletonVariants };
